// Contact Form API Service for Pantria
// Sends contact form submissions via Cloudflare Pages Function

// Contact form submission via serverless function
export const submitContactForm = async (formData) => {
    try {
        const response = await fetch('/api/contact', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
        })

        if (!response.ok) {
            const errorData = await response.json()
            throw new Error(errorData.error || `Server error: ${response.status}`)
        }

        const result = await response.json()
        return result
    } catch (error) {
        console.error('Contact Form Error:', error)
        throw error
    }
}